var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M339.237-33.772h408.177v294.351H339.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m352.744 129.509-20.105-29.486h-27.224l12.562 29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m305.415 100.023 12.562 29.486h-62.131l12.562-29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m286.911 227.49-31.065-97.981h62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M332.639 100.023h-27.224l12.562 29.486h34.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M317.977 129.509h-62.131l12.562-29.486h37.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M255.846 129.509h62.131l-31.066 97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M317.977 129.509h34.767l-20.105-29.486h-27.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M268.408 100.023h37.007l12.562 29.486h-62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m317.977 129.509-31.066 97.981-31.065-97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M97.761 372.257c13.443 14.542 80.258 10.062 93.346 0s11.141-85.514 0-93.346-84.422-10.972-93.346 0c-8.925 10.973-13.443 78.804 0 93.346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m596.527 242.69-25.634-80.849h-28.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m622.16 161.841-25.633 80.849-25.634-80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m596.527 80.859 25.633 80.849h28.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m570.893 161.708 25.634-80.849 25.633 80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M253.01 353.699v-28.433l34.629-42.986 18.091 52.979-11.465 37.397-24.638 18.014z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 45,
      lineHeight: "100%",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "green",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-56.264 254.57q.56 0 1.16.56 2.24 2.16 2.24 2.88 0 .44-.56.8-.44.32-.64.56-.08.2-2 4.84-2.48 6.08-7.52 10.76-4.32 4.04-6.28 5.08-.2.12-.36.12-.48 0-.48-.52 0-.36 1.4-1.44 2.84-2.28 5.88-6.36 3.72-4.96 5.72-10.52.96-2.68.96-3.44 0-.72-1-.72-.96 0-8.76 1.24-3.44.52-3.8.52-.68 0-1.64-.44-1.8-.88-1.8-1.44 0-.52.72-.52 8.2-.16 13.68-.96 1.28-.2 2.32-.8.4-.2.76-.2m-16.72 10q.16 0 .56.04.72.08 1.64.08 4.64 0 7.96-1.8.84-.48 1.76-.48.64 0 1.24.24.72.28.72.88 0 .84-1.96 1.64-2.72 1.16-6.48 1.16-3.28 0-5.36-.8-.56-.2-.56-.52 0-.44.48-.44",
    style: {
      fontSize: 40,
      fontFamily: "TPKaisho-GT01",
      InkscapeFontSpecification: "TPKaisho-GT01",
      textAlign: "center",
      textAnchor: "middle",
      fill: "green"
    },
    transform: "matrix(1.71214 0 0 1.81249 132.122 -460.285)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.f182293cb80334ca6fdef4b5671a372a.svg";
export { ForwardRef as ReactComponent };